export default __webpack_public_path__ + "static/media/GIS.d32778b6.jpg";